import Swal from 'sweetalert2'
import Strings from "../Lang/strings";

const swal = (title, icon = "error", cancelable = false) => {
    return Swal.fire({
        text: title,
        icon: icon,
        confirmButtonColor: "rgb(91,31,105)",
        showCancelButton: cancelable,
        confirmButtonText:Strings.okay,
        cancelButtonText:Strings.cancel,

    });

}
export default swal;
